import { createContext, useContext, type ReactNode } from "react";

interface ChatContextType {
  sendUserMessageFromSuggestion: (message: string) => void;
}

const ChatContext = createContext<ChatContextType | null>(null);

export function ChatProvider({
  children,
  sendUserMessageFromSuggestion,
}: {
  children: ReactNode;
  sendUserMessageFromSuggestion: (message: string) => void;
}) {
  return (
    <ChatContext.Provider value={{ sendUserMessageFromSuggestion }}>
      {children}
    </ChatContext.Provider>
  );
}

export function useChatContext() {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error("useChatContext must be used within ChatProvider");
  }
  return context;
}
